import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-skills-item',
  templateUrl: './skills-item.component.html',
  styleUrls: ['./skills-item.component.scss']
})
export class SkillsItemComponent implements OnInit, AfterViewChecked {

  @Input() skill;
  @Output() emitter: EventEmitter<any> = new EventEmitter();
  skillDetailContainer: boolean;

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.skillDetailContainer = false;
  }

  public toggleDetail() {
    this.emitter.emit(this.skill);
  }
  ngAfterViewChecked() {
    if (window.innerWidth < 992) {
      this.skillDetailContainer = true;
    } else {
      this.skillDetailContainer = false;
    }
    this.cd.detectChanges();
  }

}
